import {API_SERVERLESS, postFetch} from '../../../../commonApi';

export interface Parameter {
    valueString: string;
}

export function apiPostEditorContent(editorContent: {homeHtml: string}): Promise<Array<Parameter>> {
    return postFetch(`${API_SERVERLESS}/tlo/homehtml`, true, editorContent);
}
